<template>
  <v-container fluid align-start ma-0 pa-2 class="epms5080-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters class="row__dely">
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList"
                  :unUseBtnList="unUseBtnList"
                  @btnNew="btnNew"
                  @btnRetrieve="btnRetrieve(), btnRetrievePo()"
                  @btnSave="btnSave"
                  @btnPrint="btnPrint"
                  @btnDeleteAll="btnDelete('a')"
                  @btnDeleteSelect="btnDelete('s')"
                  @btnList="btnList"
                  :key="useBtnListKey"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <i-label :label="'Delivery No :'" />
                      <v-col cols="2">
                        <v-select
                          v-model="delyNo"
                          :items="delyNoList"
                          single-line
                          outlined
                          dense
                          height="32"
                          @change="btnRetrieve(), btnRetrievePo()" />
                      </v-col>
                      <b v-if="whYn === 'Y'" class="pl-2 d-flex align-center" style="height: 30px;">is Already Warehousing</b>

                      <i-label :label="'Delivery Date :'" class="pl-2" />
                      <v-col cols="2">
                        <v-text-field 
                          class="text__dely-dte"
                          dense 
                          outlined 
                          hide-details="auto"
                          readonly
                          height="32"
                          :value="delyDte"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1 pb-4">
              <v-col>
                <DxDataGrid
                  :ref="epms5080Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                  <!-- <DxPager :show-info="false" :visible="false" /> -->
                  <DxPager :visible="false" />
                  <DxEditing :allow-updating="true" />
                  <DxColumn data-field="shipNo" caption="Ship No" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn caption="POR No" width="7%" data-type="string" alignment="center" :allow-editing="false"
                                        cell-template="porNoTmpl" />
                  <template #porNoTmpl="{ data }">
                    {{ `${data.data.porNo}-${data.data.porSeq}` }}
                  </template>
                  <DxColumn data-field="block" caption="Block" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="mact" caption="Activity" width="6%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="bomSerno" width="3%" data-type="string" alignment="center" :allow-editing="false"
                                        header-cell-template="serNoTmpl" cell-template="numTmpl" />
                  <template #serNoTmpl>
                    <div>Ser.<br>No</div>
                  </template>
                  <DxColumn data-field="matlSpec" caption="Material Specification" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="uprice" caption="Unit Price" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyQty" caption="Quantity" width="5%" format="#,##0" data-type="number" alignment="right" :allow-editing="whYn !== 'Y'"
                                        :set-cell-value="delyQtyChanged" />
                  <DxColumn data-field="delyAmt" caption="Amount" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyVat" caption="VAT" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="transFee" caption="Trans. Fee" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="transVat" caption="VAT" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="govFee" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        header-cell-template="govFeeTmpl" cell-template="numTmpl" />
                   <template #govFeeTmpl>
                    <div>Gov. Fee<br>(U/Price)</div>
                  </template>
                  <template #numTmpl="{ data }">
                    {{ getNumComma(data.value) }}
                  </template>
                  <DxSelection :allow-select-all="false" :show-check-boxes-mode="whYn === 'Y' ? 'none' : 'always'" mode="multiple" />
                </DxDataGrid>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <i-label :label="'Ship No :'" />
                      <v-col cols="1">
                        <v-text-field 
                          v-model="shipNo"
                          dense 
                          outlined 
                          hide-details="auto"
                          height="32"
                        />
                      </v-col>

                      <i-label :label="'POR NO :'" class="pl-2" />
                      <v-col cols="1">
                        <v-text-field 
                          v-model="porNo"
                          dense 
                          outlined 
                          hide-details="auto"
                          height="32"
                        />
                      </v-col>

                      <i-button :text="'Retrieve'" :isCustom="true" :icon="'search'" class="pl-2" @click="btnRetrievePo(), btnRetrieve()" />

                      <i-label :label="'Delivery Plan Date :'" class="pl-2" />
                      <v-col cols="1">
                        <DxDateBox
                          :value="poDelyDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {poDelyDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>

                      <i-button :text="'Make Delivery Note'" :isCustom="true" :icon="'save'" role="btnMakeDeliveryNote" class="pl-2" @click="btnMakeDeliveryNote" />

                      <v-checkbox v-model="isAppend" label="Append Delivery Note" class="pl-2" :disabled="delyNo === 'New' || whYn === 'Y'"
                                              true-value="Y" false-value="N" />

                      <v-checkbox v-if="userGrd === 'A'" v-model="isAdmin" label="Admin" class="pl-2"
                                              true-value="Y" false-value="N" />
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1 pb-2">
              <v-col>
                <DxDataGrid
                  :ref="epms5080Ref2"
                  :data-source="dataList2" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  :sorting="{ mode: 'none' }"
                  @cellPrepared="cellPrepared2"
                  @editingStart="editingStart2"
                >
                  <DxPaging :enabled="true" :page-size="setPageSize" />
                  <DxPager :show-page-size-selector="false" />
                  <DxEditing :allow-updating="true" />
                  <DxColumn data-field="chk" caption="Select" width="50" data-type="string" alignment="center"
                                        cell-template="chkCell" :allow-editing="false" />
                                        <!-- header-cell-template="chkHeader" -->
									<!-- <template #chkHeader = "{ data: cellInfo }" >
                    <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)" />
                  </template> -->
                  <template #chkCell = "{ data: cellInfo }">
										<DxCheckBox :value="cellInfo.value" :onValueChanged="value => onValueChanged(value, cellInfo)"
                                               />
                                              <!-- :disabled="userGrd !== 'A' && (data.data.canDely === 'N' || (data.data.remainQty * 1) === 0)" /> -->
                  </template> 
                  <DxColumn data-field="shipNo" caption="Ship No" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn caption="POR No" width="7%" data-type="string" alignment="center" :allow-editing="false"
                                        cell-template="porNoTmpl" />
                  <template #porNoTmpl="{ data }">
                    {{ `${data.data.porNo}-${data.data.porSeq}` }}
                  </template>
                  <DxColumn data-field="block" caption="Block" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="firSpDlyDte" width="6%" data-type="string" alignment="center" :allow-editing="false"
                                        header-cell-template="firSpDlyDteTmpl" />
                  <template #firSpDlyDteTmpl>
                    <div>Supp.<br>Delivery Date</div>
                  </template>
                  <DxColumn data-field="matlSpec" caption="Material Specification" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false" />

                  <DxColumn data-field="poQty" caption="PO Qty" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="uprice" caption="Unit Price" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="whQty" caption="W/H Qty" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="delyQty" caption="Unit" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false"
                                        header-cell-template="delyQtyTmpl" />
                  <template #delyQtyTmpl>
                    <div>Waitting<br>W/H Qty</div>
                  </template>
                  <DxColumn data-field="remainQty" caption="Remain Qty" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="delyQty2" caption="Delivery Qty" width="6%" format="#,##0" data-type="number" alignment="right"
                                        :set-cell-value="delyQty2Changed" />
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getDelyNoList } from '@/api/view/hip/5/epms5010'
import { getEpms5080DelyList, getEpms5080PoList, epms5080InsDelivery } from '@/api/view/hip/5/epms5080'
import { epms5010ModDelivery, epms5010DelDelivery } from '@/api/view/hip/5/epms5010'
import { getNumComma, toNum, getDateFormat, getCurrentDate, trim } from '@/utils/common.js'
import iButton from '@/components/common/iButton'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'

export default {
  name: 'epms5080',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
    iButton
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      makerCd: this.$store.state.user.makerCd,
      epms5080Ref: 'epms5080Ref',
      epms5080Ref2: 'epms5080Ref2',
      setPageSize: 30,
      useBtnListKey: 0,
      useBtnList: ['btnNew', 'btnRetrieve', 'btnSave', 'btnPrint', 'btnDeleteAll', 'btnDeleteSelect', 'btnList'],
      unUseBtnList: [],
      useBtnList2: ['btnRetrieve', 'btnMakeDeliveryNote'],
      delyNo: 'New',
      delyNoList: ['New'],
      delyDte: this.$route.params.delyDte ? this.$route.params.delyDte : '',
      poDelyDte: getCurrentDate(),
      dataList: [],
      dataList2: [],
      whYn: 'N',
      shipNo: '',
      porNo: '',
      isAppend: 'N',
      isAdmin: 'N',
      userGrd: this.$store.state.user.userGrd,
      userId: this.$store.state.user.userId
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms5080Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epms5080Ref2)
    },
    searchDelyNo() {
      return this.delyNo === 'New' ? '' : this.delyNo
    }
  },
  methods: {
    init() {
      this.gridInstance.option('defaultPaging', false)
      this.grid2Instance.option('defaultPaging', false)
    },
    async getDelyNoList() {

      // console.log('this.$route.params', this.$route.params)

      const param = {
        makerCd: this.makerCd,
        delyNo: this.$route.params.delyNo ? this.$route.params.delyNo : this.searchDelyNo
      }

      // console.log('getDelyNoListParam', param)

      await getDelyNoList(param).then(res => {
        // console.log('getDelyNoListRes', res)

        const data = [...new Set(res.list.map(row => row.delyNo))]
        
        data.forEach(item => {
          this.delyNoList.push(item)
        })

        if(this.$route.params.delyNo) {
          this.delyNoList.forEach(item => {
            if(item === this.$route.params.delyNo) {
              this.delyNo = item
            }
          })
        }
      })
    },
    setBtnList() {
      if(this.whYn === 'Y') {
        this.unUseBtnList.push('btnSave', 'btnDeleteAll', 'btnDeleteSelect')
      }
      
      this.useBtnListKey++
    },
    btnNew() {
      this.delyNo = 'New'
      this.delyDte = ''
      this.btnRetrieve()
      this.btnRetrievePo()
    },
    async btnRetrieve() {
      this.gridInstance.clearSelection()
      this.dataList = []
      this.delyDte = ''
      this.poDelyDte = getCurrentDate()
      this.whYn = 'N'
      this.isAppend = 'N'
      this.isAdmin = 'N'

      this.openLoading('searching')
      
      const param = {
        makerCd: this.makerCd,
        delyNo: this.searchDelyNo
      }

      // console.log('getEpms5080DelyListRes', param)

      await getEpms5080DelyList(param).then(res => {
        // console.log('getEpms5080DelyListRes', res)

        let data = res.list

        for(let i = 0; i < data.length; i++) {
          data[i].rnum = i + 1
          data[i].orgQty = data[i].delyQty
        }

         this.dataList = data
         if(this.dataList.length > 0) {
           this.delyDte = this.poDelyDte = this.dataList[0].delyDte
           this.whYn = this.dataList[0].whYn
         }

         this.setBtnList()
      }).finally(() => {
        this.endLoading()
      })
    },
    async btnSave() {
      if(!this.searchDelyNo || this.whYn === 'Y' || this.dataList.length === 0) {
        return
      }

      // console.log('btnSave')

      await this.gridInstance.saveEditData()

      for(let i = 0; i < this.dataList.length; i++) {
        const delyQty = this.dataList[i].delyQty
        const orgQty = this.dataList[i].orgQty

        // console.log('delyQty', delyQty)
        // console.log('orgQty', orgQty)

        if(delyQty !== orgQty) {
          this.gridInstance.selectRows(i + 1, true)
        }
      }

      let saveData = await this.gridInstance.getSelectedRowsData()

      // console.log('saveData', saveData)

      if(saveData.length < 1) {
        this.vToastify(this.$t('Data is not changed.'), 'warn')
        return
      }

      this.openLoading('searching')

      saveData.forEach(item => {
        item.userId = this.userId
      })

      epms5010ModDelivery(saveData).then(res => {
        // console.log('btnSaveRes', res)

        const msg = res.body
        if(msg === 'OK') {
          notify(this.$t('Delivery Note is saved.'), 'success', 3000)
          this.btnRetrieve()
          this.btnRetrievePo()
        } else {
          this.vToastify(this.$t('An error has occured while saving delivery note.'), 'warn')
          return
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    btnPrint() {
      if(!this.delyNo) {
        return
      }

      let param = {
        as_dely_no: this.delyNo,
        as_maker_cd: this.makerCd,
        fileName: 'epms5080.jrxml'
      }

      // console.log('param', param)

      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete(gbn) {
      // console.log('gbn', gbn)

       if(!this.searchDelyNo || this.whYn === 'Y' || this.dataList.length === 0) {
        return
      }

      let question = '?'
      let selectData = await this.gridInstance.getSelectedRowsData()
      if(gbn === 'a') {
        question = 'Do you want to delete all data?'
      } else if(gbn === 's') {
        if(selectData.length < 1) {
          this.vToastify(this.$t('Data is not selected.'), 'warn')
          return
        }

        question = 'Do you want to delete selected data?'
      }

      this.vToastifyPrompt(
        this.$t(question),
        'info',
        async current => {
          let delData
          if(gbn === 'a') {
            this.gridInstance.selectAll()
            delData = await this.gridInstance.getSelectedRowsData()
          } else if(gbn === 's') {
            delData = selectData
          }
          
          epms5010DelDelivery(delData).then(res => {
            // console.log('btnDeleteRes', res)

            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Delivery Note is deleted.'), 'success', 3000)
              this.btnRetrieve()
              this.btnRetrievePo()
            } else {
              this.vToastify(this.$t('An error has occured while saving deleting note.'), 'warn')
              return
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    btnList() {
      this.$router.push('/epms5000')
    },
    async btnRetrievePo() {
      this.grid2Instance.clearSelection()
      this.dataList2 = []
      this.isAppend = 'N'

      this.openLoading('searching')

      const param = {
        makerCd: this.makerCd,
        shipNo: trim(this.shipNo).toUpperCase(),
        porNo: trim(this.porNo).toUpperCase(),
        canDely: '',
        remainDay: ''
      }

      if(this.userGrd !== 'A') {
        param.canDely = 'Y'
        param.remainDay = '21'
      } else if(this.isAdmin  === 'Y') {
        param.canDely = ''
        param.remainDay = '9999'
      } else {
        param.canDely = 'Y'
        param.remainDay = '21'
      }

      // console.log('param', param)

      await getEpms5080PoList(param).then(res => {
        // console.log('getEpms5080PoListRes', res)
        
        let data = res.list
        data.forEach(item => {
          item.chk = false
          item.delyQty2 = 0
        })

        this.dataList2 = data

        // console.log('data', data)
      }).finally(() => {
        this.endLoading()
      })
    },
    async btnMakeDeliveryNote() {
      if(this.dataList2.length < 1) {
        this.vToastify(this.$t('Data not found for delivery.'), 'warn')
        return
      }

      await this.grid2Instance.saveEditData()
      
      let makeData = await this.grid2Instance.getSelectedRowsData()
      makeData = this.$_.filter(makeData, item => {
        return item.delyQty2 > 0
      })

      if(makeData.length < 1) {
        this.vToastify(this.$t('Data not selected for delivery.'), 'warn')
        return
      }

      let canSave = true
      let delyNo = ''
      let delyDte = ''
      const vm = this
      await new Promise(function(resolve, reject) {
        if(vm.isAppend === 'Y') {
          vm.vToastifyPrompt(
            vm.$t('Do you want to append data?'),
            'info',
            current => {
              delyNo = vm.searchDelyNo
              delyDte = vm.delyDte
              resolve()
            },
            current => {
              canSave = false
              resolve()
            },
            false
          )
        } else {
          const currDate = getCurrentDate()
          delyDte = vm.poDelyDte

          if(delyDte < currDate) {
            vm.vToastify(vm.$t('Invalid delivery date.'), 'warn')
            canSave = false
            resolve()
            return
          }

          vm.vToastifyPrompt(
            vm.$t('Do you want to make new delivery note?'),
            'info',
            current => {
              resolve()
            },
            current => {
              canSave = false
              resolve()
            },
            false
          )
        }
      })

      if(!canSave) {
        return
      }

      makeData.forEach(item => {
        item.delyNo = delyNo
        item.delyDte = delyDte
        item.userId = this.userId
      })

      // console.log('makeData', makeData)

      this.openLoading()
      epms5080InsDelivery(makeData).then(async res => {
        // console.log('btnMakeRes', res)

        const resMsg = res.map.msg
        const resDelyNo = res.map.delyNo

        if(resMsg === 'OK') {
          notify(this.$t('Make delivery note is completed.'), 'success', 3000)
          await this.getDelyNoList()
          this.delyNo = resDelyNo
          this.btnRetrieve()
          this.btnRetrievePo()
        } else {
          this.vToastify(this.$t(resMsg), 'warn')
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    delyQtyChanged(newData , value , currData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      
      // console.log('currData', currData)

      const delyQty = val
      const remainQty = toNum(currData.remainQty)
      const uprice = toNum(currData.uprice)
      const tprice = toNum(currData.tprice)

      if(delyQty > remainQty) {
        this.vToastify(this.$t('Delivery Quantity is greater than remain quantity.'), 'warn')
      } else {
        newData.delyQty = val

        const quotAmt = newData.delyQty * uprice
        const transFee = newData.delyQty * tprice
        newData.delyAmt = quotAmt
        newData.transFee = transFee
      }
    },
    getNumComma(val) {
      return getNumComma(val)
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
    delyQty2Changed(newData , value , currData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0

      const delyQty = val
      const remainQty = toNum(currData.remainQty)

      if(delyQty > remainQty) {
        this.vToastify(this.$t('Delivery Quantity is greater than remain quantity.'), 'warn')
        newData.delyQty2 = 0
      } else {
        newData.delyQty2 = val
      }
    },
    editingStart2(e) {
      // console.log('e', e)
      if(e.column.dataField === 'delyQty2') {
        if(this.userGrd !== 'A' && (e.data.canDely === 'N' || Number(e.data.remainQty) === 0)) {
          e.cancel = true
        }
      }
    },
    cellPrepared(e) {
      if(e.rowType === 'header' && e.column.command === 'select') {
        e.cellElement.innerText = 'Select'
      }
    },
    cellPrepared2(e) {
      if(e.rowType === 'data' && e.rowIndex >= 0) {
        if(e.column.dataField === 'delyQty2') {
          // console.log('e', e)
          if(this.userGrd !== 'A' && (e.data.canDely === 'N' || Number(e.data.remainQty) === 0)) {
            e.cellElement.classList.add('cancel-editable-cell')
          }
        }
      }
    },
    async onValueChanged(value, cellInfo) {
      // console.log('value', value)
      // console.log('cellInfo', cellInfo)

      // if(cellInfo.rowType === 'header') {
      //   for(let i = 0; i < this.dataList2.length; i++) {
      //     this.dataList2[i].chk = value.value

      //     if(value.value) {
      //       if(this.userGrd !== 'A' && (cellInfo.data.canDely === 'N' || (cellInfo.data.remainQty * 1) === 0)) {
      //         this.grid2Instance.selectRows(i + 1, false)
      //       } else {
      //         this.grid2Instance.selectRows(i + 1, true)
      //       }
      //     } else {
      //       this.grid2Instance.deselectAll()
      //     }
      //   }
      // } else {
        if(cellInfo.rowType === 'data') {
          // this.grid2Instance.cellValue(cellInfo.rowIndex, 'chk', value.value)
          this.dataList2[cellInfo.rowIndex + (this.setPageSize * this.grid2Instance.pageIndex())].chk = value.value

          if(value.value) {
            await this.grid2Instance.selectRows([cellInfo.key], true)
          } else {
            await this.grid2Instance.deselectRows([cellInfo.key])
          }
        }
      // }
    }
  },
  async mounted() {
    this.init()
    await this.getDelyNoList()
    await this.btnRetrieve()
    await this.btnRetrievePo()
  }
}
</script>

<style lang="scss" scoped>
.epms5080-main {
  .row__dely {
    ::v-deep {
      [role=btnRetrieve] {
        .v-btn__content {
          div, i {
            color: #0000ff !important;
          }
        }
      }
    }
  }

  ::v-deep {
    [role=btnNew], [role=btnPrint], [role=btnMakeDeliveryNote] {
      .v-btn__content {
        div, i {
          color: #0000ff !important;
        }
      }
    }

    [role=btnSave] {
      :not([disabled=disabled]) {
        .v-btn__content {
          div, i {
            color: #0000ff !important;
          }
        }
      }
    }

    [role=btnDeleteAll], [role=btnDeleteSelect] {
      :not([disabled=disabled]) {
        .v-btn__content {
          div, i {
            color: #ff0000 !important;
          }
        }
      }
    }
  }

  ::v-deep.v-input--checkbox:not(.v-input--is-disabled) {
    .v-label {
      color: black;
      font-weight: bold;
    }
  }
}
</style>